import React from "react";
import IncomeAdvancedCard from "../income/IncomeAdvancedCard.component";
import { Card, CardContent, Grid, Typography } from "@mui/material";

const AdvancedMetricCard = ({ label, value, icon, loading }) => {

  return loading ? (
    <IncomeAdvancedCard />
  ) : (
    <Card
      sx={{
        border: "1px solid #E6DEB8",
        boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
      }}
    >
      <CardContent
        sx={{
          height: "65px",
          padding: 1.5,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Grid container display="flex" alignItems={"center"} spacing={1}>
          {label && (
            <Grid item xs={12}>
              <Typography pt={2}
                sx={{ fontSize: "13px" }}
              >{label}</Typography>
            </Grid>
          )}

          <Grid
            item
            container
            display={"flex"}
            alignItems="center"
            justifyContent={"left"}
          >
            {value !== null && (

              <Typography variant="h3" sx={{ fontSize: 14 }} >
                {value}
              </Typography>

            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AdvancedMetricCard;
